import React, { useContext, useState } from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDownload, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import Card from "../atoms/Card"
import { theme } from "../settings/config"
import { callFunction } from "../services/firebase.service"
import { modalContext } from "../providers/modal.provider"
import { DateTime } from "luxon"

// I dati che un maestro scrive sono suoi: deve poterli portare via e
// cancellare senza chiedere il permesso a nessuno. Sta in fondo al profilo
// perché è roba che si cerca quando serve, non che si incontra per sbaglio.
function AccountDataCard() {
	const Modal = useContext(modalContext)
	const [isExporting, setIsExporting] = useState(false)

	const handleExport = async () => {
		setIsExporting(true)
		try {
			const exportData = callFunction("exportCoachData")
			const { data } = await exportData()

			// il file si costruisce qui e resta qui: non passa da nessun server
			const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" })
			const url = URL.createObjectURL(blob)

			const link = document.createElement("a")
			link.href = url
			link.download = `incampo-dati-${DateTime.now().toFormat("yyyy-LL-dd")}.json`
			link.click()

			URL.revokeObjectURL(url)
			toast.success("Dati scaricati", { position: "top-center" })
		} catch (err) {
			toast.error(err.message || "Non sono riuscito a preparare i dati", {
				position: "top-center",
			})
		} finally {
			setIsExporting(false)
		}
	}

	return (
		<Card bg={theme.colors.surface}>
			<Text textWeight="bold" textSize="subheader" m={{ b: "0.25rem" }}>
				I tuoi dati
			</Text>
			<Text textSize="caption" textColor={theme.colors.text_light} m={{ b: "1rem" }}>
				Quello che hai scritto è tuo: puoi portartelo via quando vuoi, o farlo sparire.
			</Text>

			<Div
				d="flex"
				align="center"
				justify="space-between"
				p={{ y: "0.6rem" }}
				border="bottom"
				borderColor={theme.colors.gray_light}
				cursor="pointer"
				onClick={() => !isExporting && handleExport()}>
				<Div d="flex" align="center" style={{ gap: "0.6rem" }}>
					<FontAwesomeIcon icon={faDownload} color={theme.colors.gunmetal} />
					<Text textSize="body">
						{isExporting ? "Preparo il file..." : "Scarica i tuoi dati"}
					</Text>
				</Div>
			</Div>

			<Div
				d="flex"
				align="center"
				justify="space-between"
				p={{ y: "0.6rem" }}
				cursor="pointer"
				onClick={() => Modal.open("deleteAccount")}>
				<Div d="flex" align="center" style={{ gap: "0.6rem" }}>
					<FontAwesomeIcon icon={faTriangleExclamation} color={theme.colors.red} />
					<Text textSize="body" textColor={theme.colors.red}>
						Elimina il tuo account
					</Text>
				</Div>
			</Div>
		</Card>
	)
}

export default AccountDataCard
